import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  body: {
    padding: 20,
    color: '#333',
    fontSize: 14,
  },
  badge: {
    display: 'inline-block',
    background: '#fce500',
    color: '#222',
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    padding: '6px 12px',
    borderRadius: 20,
    marginBottom: 12,
  },
  category: {
    display: 'block',
    color: '#0b2e59',
    fontWeight: 700,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: 6,
  },
  headline: {
    margin: '0 0 8px',
    fontSize: 20,
    fontWeight: 800,
    color: '#111',
  },
  copy: {
    margin: '0 0 14px',
    fontSize: 14,
    color: '#555',
    lineHeight: 1.5,
  },
  bullets: {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 14,
    '& > * + *': {
      marginTop: 8,
    },
  },
  bullet: {
    flex: '1 1',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    background: '#f4f5f7',
    borderRadius: 8,
    padding: '10px 12px',
    fontSize: 13,
    color: '#333',
  },
  bulletIcon: {
    fontSize: 16,
    lineHeight: 1,
    marginRight: 8,
  },
  callout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    background: '#fffbe0',
    border: '1px solid #fce500',
    borderRadius: 8,
    padding: '10px 12px',
    fontSize: 13,
    color: '#333',
  },
  calloutIcon: {
    color: '#c9a600',
  },
}));

export interface Bullet {
  icon: string;
  text: string;
}

export interface StepBodyProps {
  badge?: string;
  eyebrow?: string;
  headline: string;
  description: string;
  bullets?: Bullet[];
  callout?: string;
}

export function StepBody({ badge, eyebrow, headline, description, bullets, callout }: StepBodyProps) {
  const classes = useStyles();

  return (
    <div className={classes.body}>
      {badge && <span className={classes.badge}>{badge}</span>}
      {eyebrow && <span className={classes.category}>{eyebrow}</span>}
      <h3 className={classes.headline}>{headline}</h3>
      <p className={classes.copy}>{description}</p>
      {!!bullets?.length && (
        <div className={classes.bullets}>
          {bullets.map((bullet) => (
            <div className={classes.bullet} key={bullet.text}>
              <span className={classes.bulletIcon}>{bullet.icon}</span>
              <span>{bullet.text}</span>
            </div>
          ))}
        </div>
      )}
      {callout && (
        <div className={classes.callout}>
          <span className={classes.calloutIcon}>&#10022;</span>
          <span>{callout}</span>
        </div>
      )}
    </div>
  );
}

export default StepBody;
